// Nome do item para os avisos do rodapé (observação obrigatória, ART/RRT). Ao escolher o item na tela, a linha
// guarda o nome do catálogo com o código na frente ("269 - GERADOR", ou "269 - CODFORN - GERADOR"); o aviso
// mostra só o nome (Rafael 22/10). Tira os prefixos pelo código e codigoFornecedor do próprio produto.
const tirarPrefixo = (nome, prefixo) => {
    const p = String(prefixo ?? '').trim();
    if (!p) return nome;
    return nome.startsWith(`${p} - `) ? nome.slice(p.length + 3) : nome;
};

export function nomeItemAviso(produto) {
    let nome = String(produto?.nome ?? '').trim();
    nome = tirarPrefixo(nome, produto?.codigo);
    nome = tirarPrefixo(nome, produto?.codigoFornecedor);
    return nome.trim();
}
